import React from "react";
import {API_URL} from "../../settings/local_settings";
import {Spinner} from "../Spinner";
import {EditElementModalForm} from "../EditElementModalForm";
import BudgetValueInput from "../elements/BudgetValueInput";
import {APIClient} from "../../utils/APIClient";
import BudgetPartialGoalsConfiguration from "../elements/BudgetPartialGoalsConfiguration";
import {BudgetHelper} from "../../utils/BudgetHelper";
import { withTranslation } from 'react-i18next';

class EditBudgetFormComponent extends EditElementModalForm {

    constructor(props) {
        super(props);
        this.state = {
            clientName: this.props.clientName,
            businessUnitName: this.props.businessUnitName !== undefined ? this.props.businessUnitName: null,
            campaignName: null,
            adgroupName: null,
            budgetAmount: this.props.budget,
            budgetFromDate: this.props.budgetFromDate,
            budgetToDate: this.props.budgetToDate,
            budgetCurrency: null,
            budgetPartialGoals: this.getBudgetPartialGoalsWithDates(this.props.budgetPartialGoals),
            loading: true,
            saving: false
        };

        this.handleAmountChange = this.handleAmountChange.bind(this);
        this.handleBudgetPartialGoalsChange = this.handleBudgetPartialGoalsChange.bind(this);
        this.handleCurrencyChange = this.handleCurrencyChange.bind(this);
    }

    componentDidMount() {
        if(this._isEditingCampaignBudget())
            this.getCampaignBudgetData();
        else if(this._isEditingAdgroupBudget())
            this.getAdgroupBudgetData();
        else
            this.getBusinessUnitCurrency();
    }

    getBusinessUnitCurrency() {
        new APIClient(this.getBusinessUnitDataUrl()).call('GET').then((response) => {
            if (response.status === 'ERROR') {
                alert(response.error_message);
            } else if (response.status === 'OK') {
                this.setState({
                    budgetCurrency: response.data.budget_currency,
                    loading: false
                });
            }
        })
    }

    getCampaignBudgetData() {
        new APIClient(this.getCampaignBudgetUrl()).call('GET').then((response) => {
            if (response.status === 'ERROR') {
                alert(response.error_message);
            } else if (response.status === 'OK') {
                this.setState({
                    campaignName: response.data.campaign_name,
                    businessUnitName: response.data.business_unit_name,
                    clientName: response.data.agency_client_name,
                    budgetCurrency: response.data.budget_currency,
                    budgetAmount: response.data.allocated_budget,
                    loading: false
                });
            }
        })
    }

    getAdgroupBudgetData() {
        new APIClient(this.getAdgroupBudgetUrl()).call('GET').then((response) => {
            if (response.status === 'ERROR') {
                alert(response.error_message);
            } else if (response.status === 'OK') {
                this.setState({
                    campaignName: response.data.campaign_name,
                    adgroupName: response.data.adgroup_name,
                    businessUnitName: response.data.business_unit_name,
                    clientName: response.data.agency_client_name,
                    budgetCurrency: response.data.budget_currency,
                    budgetAmount: response.data.allocated_budget,
                    loading: false
                });
            }
        })
    }

    handleAmountChange(newAmount) {
        this.setState({
            budgetAmount: newAmount
        });
    }

    handleCurrencyChange(newCurrency) {
        this.setState({
            budgetCurrency: newCurrency
        });
    }

    handleBudgetPartialGoalsChange(budgetPartialGoals) {
        this.setState({...this.state, budgetPartialGoals: budgetPartialGoals});
    }

    _isEditingCampaignBudget() {
        return this.props.campaignsConfigurationId !== undefined
            && this.props.campaignsConfigurationId !== null
            && this.props.campaignId !== undefined
            && this.props.campaignId !== null;
    }

    _isEditingAdgroupBudget() {
        return this.props.campaignsConfigurationId !== undefined
            && this.props.campaignsConfigurationId !== null
            && this.props.adgroupId !== undefined
            && this.props.adgroupId !== null;
    }

    getSubmitUrl() {
        if(this._isEditingCampaignBudget())
            return this.getCampaignBudgetUrl()
        else if(this._isEditingAdgroupBudget())
            return this.getAdgroupBudgetUrl()
        else
            return API_URL + `business-unit/${this.props.businessUnitId}/modify-budget/`;
    }

    getBusinessUnitDataUrl() {
        return API_URL + `business-unit/${this.props.businessUnitId}/edit`;
    }

    getCampaignBudgetUrl() {
        return API_URL + `campaigns-configurations/${this.props.campaignsConfigurationId}/modify-campaign-budget/${this.props.campaignId}/`;
    }

    getAdgroupBudgetUrl() {
        return API_URL + `campaigns-configurations/${this.props.campaignsConfigurationId}/modify-adgroup-budget/${this.props.adgroupId}/`;
    }

    getDataToSubmit(event) {
        return {
            'budget': this.state.budgetAmount,
            'budget_currency': this.state.budgetCurrency,
            'partial_goals': this.getBudgetPartialGoalsWithYYYYMMDDDates()
        };
    }

    formatYYYYMMDDToDate(yyyymmdd) {
        const year = parseInt(yyyymmdd.slice(0, 4), 10);
        const month = parseInt(yyyymmdd.slice(4, 6), 10) - 1; // Months are 0-indexed in JavaScript
        const day = parseInt(yyyymmdd.slice(6, 8), 10);

        return new Date(year, month, day);
    }

    getBudgetPartialGoalsWithYYYYMMDDDates() {
        return  BudgetHelper.BudgetPartialGoalTranslateToSubmit(this.state.budgetPartialGoals);
    }

    getBudgetPartialGoalsWithDates(budgetPartialGoals) {
        const dic = [];

        if(budgetPartialGoals === undefined || budgetPartialGoals === null)
            return [];

        budgetPartialGoals.forEach(bpd => {
            dic.push({
                'date': bpd.date ? this.formatYYYYMMDDToDate(bpd.date) : null,
                'value': bpd.value,
                'type': bpd.type
            });
        })
        return dic;
    }

    renderSaveButton() {
        if (this.state.saving === false) {
            const { t } = this.props;
            return <input type="submit" value={t('client.save_button')} className="btn -submit"/>
        } else {
            return <Spinner color="positive small"/>;
        }
    }

    renderFormFields() {
        if (this.state.loading === true) {
            return <Spinner color="positive small"/>;
        }

        return <div className="modal-section">
            <div className="row mb-3 pb-0">
                <div className="col-6">
                    <label>Cliente</label>
                    <input name="client" type="text" value={this.state.clientName} readOnly="readonly"
                           className="form-control"/>
                </div>
                {this.renderBusinessUnitName()}
            </div>
            {this.renderCampaignAndAdgroupNameRow()}
            <div className="row mb-3 pb-0">
                <div className="col-12">
                    <label>Presupuesto</label>
                </div>
                <div className="row col-12">
                    <div className="col-md-6 pe-0">
                        <BudgetValueInput currencyReadOnly={this._isEditingCampaignBudget() || this._isEditingAdgroupBudget()}
                                          canEditCurrency={!(this._isEditingCampaignBudget() || this._isEditingAdgroupBudget())}
                                          onCurrencyChange={this.handleCurrencyChange}
                                          onAmountChange={this.handleAmountChange}
                                          budgetCurrency={this.state.budgetCurrency}
                                          budgetAmount={this.state.budgetAmount}
                        />
                    </div>
                </div>
                <div className="row col-12">
                    <BudgetPartialGoalsConfiguration enabled={(this.state.budgetPartialGoals !== null && this.state.budgetPartialGoals !== undefined && this.state.budgetPartialGoals.length > 0)}
                                                     budgetPeriodType={this.props.budgetPeriodType}
                                                     budgetFromDate={this.props.budgetFromDate}
                                                     budgetToDate={this.props.budgetToDate}
                                                     budgetPartialGoals={this.state.budgetPartialGoals}
                                                     onChange={this.handleBudgetPartialGoalsChange}
                                                     budgetTotalAmount={this.state.budgetAmount}
                    />
                </div>
            </div>
        </div>;
    }

    renderBusinessUnitName() {
        if(!this.state.businessUnitName)
            return null;

        return <div className="col-6">
            <label>Línea de control</label>
            <input name="business_unit" type="text" value={this.state.businessUnitName} readOnly="readonly"
                   className="form-control"/>
        </div>;
    }

    renderCampaignAndAdgroupNameRow() {
        if(!this._isEditingCampaignBudget() && !this._isEditingAdgroupBudget())
            return null;

        let adgroupSection = "";
        if(this._isEditingAdgroupBudget()) {
            adgroupSection = <div className="col-6">
                                <label>Grupo de anuncio</label>
                                <input name="adgroup" type="text" value={this.state.adgroupName} readOnly="readonly"
                                       className="form-control"/>
                            </div>;
        }

        return <div className="form-row mb-3 pb-0">
            <div className="col-6">
                <label>Campaña</label>
                <input name="campaign" type="text" value={this.state.campaignName} readOnly="readonly" className="form-control"/>
            </div>
            {adgroupSection}
        </div>
    }
}

export const EditBudgetForm = withTranslation()(EditBudgetFormComponent);
